<template>
  <div>
    <!-- 温度记录仪查询表单 -->
    <el-form
    :model="search_form"
    label-width="0"
    class="search_form"
    ref="search_form_temp"
    >
      <el-form-item v-if="$store.state.search_form_show" class="search_text" label="" prop="traceId">
        <el-input placeholder="WMS单号" v-model="search_form.traceId"></el-input>
      </el-form-item>
      <el-form-item v-if="$store.state.search_form_show" class="search_text" label="" prop="erpNo">
        <el-input placeholder="交货单号" v-model="search_form.erpNo"></el-input>
      </el-form-item>
      <el-form-item v-if="$store.state.search_form_show" class="search_text" label="" prop="deviceId">
        <el-input placeholder="设备编号" v-model="search_form.deviceId"></el-input>
      </el-form-item>
      <el-form-item v-if="$store.state.search_form_show" class="search_text" label="" prop="consigneeName">
        <el-input placeholder="客户名称" v-model="search_form.consigneeName"></el-input>
      </el-form-item>
      <el-form-item v-if="$store.state.search_form_show" class="search_address" label="" prop="address">
        <el-input placeholder="地址" v-model="search_form.address"></el-input>
      </el-form-item>
      <el-form-item class="search_other">
        <el-button
        v-if="$store.state.search_form_show"
        type="primary"
        icon="el-icon-search"
        class="operate_btn"
        @click="search_temp_list"
        >查询</el-button>
        <el-button
        v-if="$store.state.search_form_show"
        icon="el-icon-close"
        class="operate_btn"
        @click="reset_temp_list"
        >重置</el-button>
        <el-button
        icon="el-icon-caret-right"
        type="primary"
        class="operate_btn"
        @click="to_scroll"
        >{{scroll_flag}}</el-button>
        <el-button
        icon="el-icon-rank"
        type="primary"
        class="operate_btn"
        @click="toggleFullScreen"
        >{{$store.state.full_screen_text}}</el-button>
      </el-form-item>
    </el-form>
    <!-- 温度记录仪列表 -->
    <el-row :gutter="6">
      <el-col
      :span="6"
      ref="scroll_temp"
      :style="{height:map_height}"
      class="list_left">
        <el-card
        v-for="(item,index) in temp_list"
        :key="index"
        @click.native="control_style(index,item,$event)"
        class="card_class"
        :class="now_index==index?'card_bg':''"
        shadow="hover">
          <div class="pane_label_top">
            <span>设备编号：<span>{{item.deviceId}}</span></span>
            <span>温度：<span>{{item.deviceValue}}</span>℃</span>
          </div>
          <div class="pane_label_bottom">所在位置：<span>{{item.location}}</span></div>
        </el-card>
      </el-col>
      <el-col :span="5">
        <el-card>
          <div slot="header" class="order_header">
            <h2>所载订单</h2>
          </div>
          <div class="order_content">
            <p>WMS单号：<span>{{now_row.traceId}}</span></p>
            <p>客户名：<span>{{now_row.consigneeName}}</span></p>
            <p>收货地址：<span>{{now_row.address}}</span></p>
            <p>交货单号：<span>{{now_row.erpNo}}</span></p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="13" :style="{height:map_height}">
        <!-- 地图控件 -->
        <baidu-map
        :center="center"
        :scroll-wheel-zoom="true"
        :zoom="zoom"
        id="amap"
        @zoomend="zoomend"
        @moveend="moveend"
        @ready="handler">
          <!-- <bm-marker
          v-for="(item,index) in temp_list"
          :key="index"
          :position="{lng:item.lng,lat:item.lat}"
          :dragging="false"
          :zIndex="label_index==index?2:0"
          >
          </bm-marker> -->
          <bm-label
          v-for="(item,index) in temp_list"
          :key="index"
          :position="{lng:item.lng,lat:item.lat}"
          @click="label_click(index,item,$event)"
          :content="item.deviceId"
          :labelStyle="{color:label_index==index?'red':'rgb(64, 158, 255)',
          cursor:'pointer',
          fontSize : '14px',
          zIndex:label_index==index?2:0,
          border:'1px solid rgb(64, 158, 255)'}"/>
        </baidu-map>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default{
    data() {
      return{
        //温度记录仪查询表单
        search_form:{
          traceId:'',
          erpNo:'',
          deviceId:'',
          consigneeName:'',
          address:''
        },
        //温度记录仪列表
        now_index:0,
        temp_list:[],
        //数据行
        now_row:{},
        //地图控件
        //地图初始化坐标
        BMap:null,
        center:{lng:'',lat:''},
        zoom:8,
        label_index:0,
        //自动轮播初始化
        scroll_temp:null,
        //自动轮播开关
        scroll_status:true,
        scroll_flag:'开始轮播',
        //百度地图自适应高度
        map_height:500+'px'
      }
    },
    created() {
      if(this.$route.query.row){
        this.now_index=this.$route.query.row.index
        this.label_index=this.$route.query.row.index
      }
    },
    mounted() {
      window.addEventListener('keydown',(event)=>{
        const e=event||window.event
        if(e&&e.keyCode==122){
          e.preventDefault()
        }
      })
    },
    watch:{
      '$route'(to,from){
        if(to.name=='temp_detail'){
          if(this.$route.query.row){
            this.now_index=this.$route.query.row.index
            this.label_index=this.$route.query.row.index
          }else{
            this.now_index=0
            this.label_index=0
          }
          //获取实时温度列表
          this.get_temp_list('load')
        }
      }
    },
    updated() {
      let height=document.querySelector('.card_class').scrollHeight+10
      document.querySelector('.list_left').scrollTop=height*this.now_index
    },
    beforeDestroy() {
      clearInterval(this.scroll_temp)
    },
    methods:{
      //初始化地图控件
      handler(e){
        //获取实时温度列表
        this.get_temp_list('load')
      },
      //地图控件更改缩放级别
      zoomend(e){
        this.zoom=e.target.getZoom()
      },
      //地图控件移动结束事件
      moveend(e){

      },
      //获取实时温度列表
      get_temp_list(load_status){
        this.$axios({
          method:'get',
          url:this.publicAjax.extra_path+'/middle/overView/realTimeDetail',
          params:this.search_form
        }).then(data=>{
          if(data.data.success==true){
            if(!data.data.data){
              return false
            }
            this.temp_list=data.data.data
            let myGeo=new BMap.Geocoder({extensions_town: true})
            if(this.temp_list.length==0){
              this.now_row={}
              this.center.lng=''
              this.center.lat=''
              this.scroll_status=true
              this.scroll_flag='开始轮播'
              clearInterval(this.scroll_temp)
              return false
            }
            if(load_status=='load'){
              setTimeout(()=>{
                this.now_row=this.temp_list[this.now_index]
                this.center.lng=this.temp_list[this.now_index].lng
                this.center.lat=this.temp_list[this.now_index].lat
              },300)
            }
            this.temp_list.forEach((item)=>{
              myGeo.getLocation(new BMap.Point(item.lng, item.lat),result=>{
                this.$set(item,'location',result.address)
              })
            })
          }else{
            this.$message.warning(data.data.message)
          }
        })
      },
      //查询实时温度列表
      search_temp_list(){
        //获取实时温度列表
        this.get_temp_list('load')
      },
      //重置实时温度列表
      reset_temp_list(){
        this.search_form.traceId=''
        this.search_form.erpNo=''
        this.search_form.deviceId=''
        this.search_form.consigneeName=''
        this.search_form.address=''
        this.$refs['search_form_temp'].resetFields()
        //获取实时温度列表
        this.get_temp_list('load')
      },
      //控制列表样式
      control_style(index,item,e){
        this.now_index=index
        this.label_index=index
        this.now_row=item
        this.center.lng=item.lng
        this.center.lat=item.lat
      },
      //地图控件标签点击事件
      label_click(index,item,event){
        this.label_index=index
        this.now_index=index
        this.now_row=item
        this.center.lng=item.lng
        this.center.lat=item.lat
        let height=document.querySelector('.card_class').scrollHeight+10
        document.querySelector('.list_left').scrollTop=height*this.now_index
      },
      //自动轮播
      to_scroll(){
        let height=document.querySelector('.card_class').scrollHeight+10
        if(this.scroll_status==true){
          this.scroll_status=false
          this.scroll_flag='停止轮播'
          this.scroll_temp=setInterval(()=>{
            this.now_index++
            this.label_index++
            if(this.now_index==this.temp_list.length){
              this.now_index=0
              this.label_index=0
            }
            document.querySelector('.list_left').scrollTop=height*this.now_index
            this.now_row=this.temp_list[this.now_index]
            this.center.lng=this.now_row.lng
            this.center.lat=this.now_row.lat
          },5000)
        }else{
          this.scroll_status=true
          this.scroll_flag='开始轮播'
          clearInterval(this.scroll_temp)
        }
      },
      //全屏/退出全屏
      toggleFullScreen(){
        //控制菜单栏显隐
        this.$store.state.side_flag=!this.$store.state.side_flag
        if(this.$store.state.side_flag==true){
          this.$store.state.side_left=-260+'px'
          this.$store.state.body_left=40+'px'
        }else{
          this.$store.state.side_left=''
          this.$store.state.body_left=''
        }
        this.$store.state.full_screen=!this.$store.state.full_screen
        if(this.$store.state.full_screen==true){
          //全屏模式
          this.$store.state.full_screen_text='退出全屏'
          this.$store.state.search_form_show=false
          const elem=document.documentElement
          if(elem.requestFullscreen){
            elem.requestFullscreen()
          }else if(elem.mozRequestFullScreen){
            elem.mozRequestFullScreen()
          }else if(elem.webkitRequestFullscreen){
            elem.webkitRequestFullscreen()
          }else if(elem.msRequestFullscreen){
            elem.msRequestFullscreen()
          }
          window.onresize=()=>{
            return (()=>{
              this.map_height=window.innerHeight-100+'px'
            })()
          }
        }else{
          //退出全屏
          this.$store.state.full_screen_text='全屏'
          this.$store.state.search_form_show=true
          if(document.exitFullscreen){
            document.exitFullscreen()
          }else if(document.mozCancelFullScreen){
            document.mozCancelFullScreen()
          }else if(document.webkitExitFullscreen){
            document.webkitExitFullscreen()
          }else if(document.msExitFullscreen){
            document.msExitFullscreen()
          }
          window.onresize=()=>{
            return (()=>{
              this.map_height=500+'px'
            })()
          }
        }
      }
    }
  }
</script>

<style scoped>
  .search_text{
    width: 24%;
    display: inline-block;
  }
  .search_address,.search_other{
    width: 49%;
    display: inline-block;
  }
  .list_left{
    overflow-y: auto;
  }
  .card_class:hover{
    cursor: pointer;
  }
  .card_bg{
    background: linear-gradient(to right,rgba(255,255,255,0.1),rgba(64, 158, 255,0.1));
  }
  .pane_label_top{
    display: flex;
    justify-content: space-between;
  }
  .pane_label_top>span{
    color: darkgray;
  }
  .pane_label_top>span>span{
    font-weight: 600;
    color: #303133;
  }
  .pane_label_bottom{
    line-height: 20px;
    text-align: left;
    margin: 10px 0 0;
    color: darkgray;
  }
  .pane_label_bottom>span{
    font-weight: 600;
    color: #303133;
  }
  /deep/ .el-card{
    margin-bottom: 10px;
  }
  .pane_label_bottom{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /deep/ .card_class .el-card__body{
    height: 80px;
  }
  .order_header h2{
    font-weight: 600;
    font-size: 16px;
  }
  .order_content p{
    padding-bottom: 5px;
    color: darkgray;
  }
  .order_content span{
    font-weight: 600;
    color: #303133;
  }
  /* 地图控件 */
  #amap{
    width: 100%;
    height: 100%;
  }
  /* 其他 */
  .operate_btn{
    margin-right: 0px;
  }
  .operate_btn+.operate_btn{
    margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/temp_detail.vue